import React, { useState } from 'react';
import Switch from "react-switch";
import { ICCheck } from '../../../assets';
import { Button, Spacer } from '../../atoms';
import './Pricing.scss';

export default function Pricing() {

  const [checked, setChecked] = useState(false)
  const handleChange = () => {
    checked ? setChecked(false) : setChecked(true)
  }


  return (
    <div className="cardContainer">
      <div className="cardUtil">
        <span className="titleCard d-block">Tier System</span>
        <Spacer h={20} />
        <div className="priceWrapper p-3">
          <div className="row">
            <span className="badgeSave">Save up to 20% with yearly</span>
            <div className="col-12 billPeriod">
              <span>Bill Monthly</span>
              <Spacer w={5} />
              <Switch
                onChange={handleChange}
                checkedIcon={false}
                uncheckedIcon={false}
                offColor="#F56B3F"
                onColor="#F56B3F"
                checked={checked}
              />
              <Spacer w={5} />
              <span>Bill Yearly</span>
            </div>
            <Spacer h={50} />
            <div className="col-lg-4">
              <div className="cardPrice">
                <div className="plan">
                  <div className="lablePlan">
                    <span className="title">Free</span>
                  </div>
                  <small className="desc">One project for personal user</small>
                </div>
                <div className="price">
                  <div className="priceStart">
                    <h2>$0</h2><span>/mo</span>
                  </div>
                </div>
                <div className="featurGet">
                  <div className="item">
                    <img src={ICCheck} alt="" />
                    <span>3 people</span>
                  </div>
                  <div className="item">
                    <img src={ICCheck} alt="" />
                    <span>Limited features</span>
                  </div>
                  <div className="item">
                    <img src={ICCheck} alt="" />
                    <span>Free Forever</span>
                  </div>
                </div>
                <Spacer h={50} />
                <div className="action">
                  <Button varian="" width={150} label="Try Free" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cardPrice">
                <div className="plan">
                  <div className="lablePlan">
                    <span className="title">Standart Plan</span>
                    <span className="badgePlan">Premium</span>
                  </div>
                  <small className="desc">Unlimited project + business features</small>
                </div>
                <div className="price">
                  <span>Start At:</span>
                  <div className="priceStart">
                    <h2>$24</h2><span>.95/mo</span>
                  </div>
                </div>
                <div className="selectSize">
                  <select className="form-select form-select-lg custom-input">
                    <option value="">Select Team Size</option>
                    <option value="1">Team 1</option>
                    <option value="2">Team 2</option>
                    <option value="3">Team 3</option>
                  </select>
                </div>
                <div className="featurGet">
                  <div className="item">
                    <img src={ICCheck} alt="" />
                    <span>Get Workloads, baselines, & more</span>
                  </div>
                  <div className="item">
                    <img src={ICCheck} alt="" />
                    <span>Free 30-day trial. Cancel anytime.</span>
                  </div>
                </div>
                <Spacer h={50} />
                <div className="action">
                  <Button varian="purple" width={150} label="Try Standart" />
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cardPrice">
                <div className="plan">
                  <div className="lablePlan">
                    <span className="title">Edvanced Plan</span>
                    <span className="badgePlan">Premium</span>
                  </div>
                  <small className="desc">Unlimited project + business features</small>
                </div>
                <div className="price">
                  <span>Start At:</span>
                  <div className="priceStart">
                    <h2>$29</h2><span>.95/mo</span>
                  </div>
                </div>
                <div className="selectSize">
                  <select className="form-select form-select-lg custom-input">
                    <option value="">Select Team Size</option>
                    <option value="1">Team 1</option>
                    <option value="2">Team 2</option>
                    <option value="3">Team 3</option>
                  </select>
                </div>
                <div className="featurGet">
                  <div className="item">
                    <img src={ICCheck} alt="" />
                    <span>Standart Features + time tracking & hourly estimating</span>
                  </div>
                  <div className="item">
                    <img src={ICCheck} alt="" />
                    <span>Free 30-day trial. Cancel anytime.</span>
                  </div>
                </div>
                <Spacer h={50} />
                <div className="action">
                  <Button varian="purple" width={150} label="Try Edvanced" />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}
